import React from "react";
import Spinner from "presentation/components/Shared/Spinner";

interface MobileLoadingOverlayProps {
    visible: boolean;
    message?: string;
    zIndex?: number;
}

export const MobileLoadingOverlay: React.FC<MobileLoadingOverlayProps> = ({
    visible,
    message = "A carregar...",
    zIndex = 9999,
}) => {
    if (!visible) return null;

    return (
        <div
            className="fixed top-0 left-0 w-screen h-screen flex flex-column justify-content-center align-items-center"
            style={{
                backgroundColor: "rgba(255, 255, 255, 0.75)",
                backdropFilter: "blur(3px)",
                zIndex,
            }}
        >
            <Spinner />
            {message && (
                <span className="text-sm font-semibold mt-2" style={{ color: "#0084D1" }}>
                    {message}
                </span>
            )}
        </div>
    );
};

export default MobileLoadingOverlay;